import { render } from "./z-dashboard-item.vue?vue&type=template&id=4f7171d4"
import script from "./z-dashboard-item.vue?vue&type=script&lang=js"
export * from "./z-dashboard-item.vue?vue&type=script&lang=js"

import "./z-dashboard-item.vue?vue&type=style&index=0&id=4f7171d4&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__